import React from 'react';
import c from 'classnames';

import { Plus } from '@lyearn/icons';
import { BaseButton, Stack, Typography } from '@lyearn/ui';
import { TypographyVariants } from '@lyearn/ui';

import { COMMON_BUTTON_STYLE } from '../utils';
import {
  BUTTON_CONFIG,
  buttonStyles,
  ICON_CONFIG,
  ICON_CONTAINER_CONFIG,
  SUB_TITLE_VARIANT,
  TITLE_CONFIG,
  TITLE_CONTAINER_CONFIG,
  TITLE_VARIANT,
} from './styles';
import { LargeAddBlockProps } from './types';

const buttonClasses = {
  startIcon: 'm-0',
};

const startIconRenderer = (length: 'short' | 'long', usage: 'user' | 'content') => (
  <Stack
    alignItems="center"
    className={c('bg-bg-tertiary', ICON_CONTAINER_CONFIG[usage][length])}
    justifyContent="center">
    <Plus className={c('text-icon-placeholder', ICON_CONFIG[length])} />
  </Stack>
);

const LargeButton = React.forwardRef((props: LargeAddBlockProps, ref: any) => {
  const {
    usage = 'content',
    length = 'long',
    startIcon = startIconRenderer(length, usage),
    className,
    title,
    subTitle,
    classes = buttonClasses,
    ...rest
  } = props;

  return (
    <BaseButton
      ref={ref}
      className={c(COMMON_BUTTON_STYLE, buttonStyles, className, BUTTON_CONFIG[length])}
      classes={classes}
      startIcon={startIcon}
      {...rest}>
      <Stack alignItems="start" className={TITLE_CONTAINER_CONFIG[length]} direction="col">
        <Typography
          className={c('button-text text-text-placeholder', TITLE_CONFIG[length])}
          numberOfLines={1}
          variant={TITLE_VARIANT[length] as TypographyVariants}>
          {title}
        </Typography>
        <Typography
          className="button-text text-text-placeholder"
          numberOfLines={1}
          variant={SUB_TITLE_VARIANT[length] as TypographyVariants}>
          {subTitle}
        </Typography>
      </Stack>
    </BaseButton>
  );
});

export default React.memo(LargeButton);
export type { LargeAddBlockProps };
